import "./Rightside.css";
import News from "./News.js";
const Rightside = (props) => {
  return (
    <div className="right__side">
      <div className="right__top">
        <div className="right__header">
          <p>Linkedin News</p>
          <img src="https://i.ibb.co/37023mw/download.png" alt="info icon" />
        </div>
        <div className="news">
          <News />
          <News />
          <News />
          <News />
        </div>
        <div className="show__more">Show more</div>
      </div>
      <img
        className="right__side__ad"
        src="https://media.licdn.com/media/AAYQAgTPAAgAAQAAAAAAACeUyGWuWBhQQLyxe1gEMEaZgw.png"
        alt="Linkedin is Hiring"
      />
      <div className="a">
        <img
          className="imga"
          src="https://static-exp1.licdn.com/sc/h/6zm111mce7vohqze950ilreo4"
          alt="brand"
        />
        <div>
          <br></br>
          Our mission is to connect the world’s professionals <br></br>to allow
          them to be more productive and successful
        </div>
      </div>
    </div>
  );
};

export default Rightside;
